"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pushWarning = exports.pushSuccess = exports.pushFail = exports.push = exports.close = void 0;

var _utils = require("@package/utils");

var _slice = require("./slice");

function errorDataToString(_ref) {
  var _ref$code = _ref.code,
      code = _ref$code === void 0 ? '0.0.1' : _ref$code,
      _ref$message = _ref.message,
      message = _ref$message === void 0 ? 'Что-то пошло не так' : _ref$message,
      _ref$correlationId = _ref.correlationId,
      correlationId = _ref$correlationId === void 0 ? null : _ref$correlationId;
  var resultStr = "[".concat(code, "] | ").concat(message);

  if (correlationId) {
    resultStr += " | correlationId: ".concat(correlationId);
  }

  return resultStr;
}

var close = function close(uuid) {
  return function (dispatch) {
    dispatch((0, _slice.closeNotificationAction)(uuid));
  };
};

exports.close = close;

var push = function push(data) {
  return function (dispatch) {
    data['uuid'] = (0, _utils.UUID)();
    dispatch((0, _slice.pushNotificationAction)(data));
  };
};

exports.push = push;

var pushFail = function pushFail(data) {
  return function (dispatch) {
    dispatch((0, _slice.pushNotificationAction)({
      title: 'Что-то пошло не так. Пожалуйста, обратитесь в службу поддержки',
      content: errorDataToString(data),
      autoClose: false,
      mode: 'danger',
      uuid: (0, _utils.UUID)()
    }));
  };
};

exports.pushFail = pushFail;

var pushWarning = function pushWarning(data) {
  return function (dispatch) {
    dispatch((0, _slice.pushNotificationActionOnce)({
      uuid: data.uuid,
      title: data.title,
      content: data.content,
      autoClose: false,
      mode: 'warning',
      allowHTML: true
    }));
  };
};

exports.pushWarning = pushWarning;

var pushSuccess = function pushSuccess(data) {
  return function (dispatch) {
    dispatch((0, _slice.pushNotificationAction)({
      title: data,
      autoClose: true,
      mode: 'success',
      uuid: (0, _utils.UUID)()
    }));
  };
};

exports.pushSuccess = pushSuccess;